import { useState } from "react";
import LogoImg from "../Assets/Images/SpaceX.png";
import { Link } from "react-router-dom";
import "../Css/navbar.css";

const SERVICE_LINKS = [
  { label: "Metaverse", to: "/metaverse" },
  { label: "Artificial Intelligence", to: "/artificialIntellegence" },
  { label: "Web Development", to: "/webdev" },
  { label: "Mobile App Development", to: "/appdev" },
  { label: "Logistics & Transport", to: "/logistics" },
];

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);

  const closeMenu = () => {
    setIsOpen(false);
    setServicesOpen(false);
  };

  const linkClass =
    "block py-2 px-3 text-base sm:text-lg text-gray-200 rounded hover:bg-white/5 md:hover:bg-transparent md:hover:text-customRed md:p-0";

  return (
    <nav className="glass-nav fixed w-full top-0 start-0 z-2000">
      <div className="max-w-screen-xl flex flex-wrap items-center justify-between mx-auto px-4 py-3 md:p-4">
        <Link to="/" className="flex items-center" onClick={closeMenu}>
          <img src={LogoImg} className="h-12 sm:h-16 md:h-20 w-auto" alt="SpaceX Pakistan" />
        </Link>

        <div className="flex md:order-2 items-center gap-2 md:gap-0">
          <Link to="/contactUs" className="hidden md:inline-block">
            <button
              type="button"
              className="text-white bg-customRed neon-btn cursor-pointer focus:outline-none font-bold rounded-full text-sm px-7 py-3 hover:scale-110 transition ease-in-out text-center"
            >
              Get a Quote
            </button>
          </Link>
          <button
            onClick={() => setIsOpen(!isOpen)}
            type="button"
            aria-label="Toggle menu"
            className="text-white bg-customBlue hover:bg-customBlue focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-4 py-2 text-center md:hidden"
          >
            {isOpen ? (
              <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            ) : (
              <svg className="w-5 h-5" fill="none" viewBox="0 0 17 14" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M1 1h15M1 7h15M1 13h15" />
              </svg>
            )}
          </button>
        </div>

        <div
          className={`${
            isOpen ? "block" : "hidden"
          } items-center justify-between w-full md:flex md:w-auto md:order-1`}
        >
          <ul className="flex flex-col p-4 md:p-0 mt-2 md:mt-0 font-medium border border-white/10 rounded-2xl bg-nightSoft md:space-x-6 lg:space-x-8 md:flex-row md:border-0 md:bg-transparent">
            <li>
              <Link to="/about" className={linkClass} onClick={closeMenu}>
                About Us
              </Link>
            </li>

            <li className="dropdown md:relative">
              <div className="flex items-center justify-between md:block">
                <Link to="/services" className={linkClass} onClick={closeMenu}>
                  Services
                </Link>
                <button
                  type="button"
                  aria-label="Toggle services menu"
                  className="md:hidden px-3 py-2 text-gray-300"
                  onClick={() => setServicesOpen(!servicesOpen)}
                >
                  {servicesOpen ? "−" : "+"}
                </button>
              </div>
              <div className={`dropdown-content ${servicesOpen ? "dropdown-open" : ""}`}>
                {SERVICE_LINKS.map((item) => (
                  <Link
                    key={item.to}
                    className="text-white border-b border-white/10 hover:text-customRed hover:bg-white/5 text-sm sm:text-base"
                    to={item.to}
                    onClick={closeMenu}
                  >
                    {item.label.toUpperCase()}
                  </Link>
                ))}
              </div>
            </li>

            <li>
              <Link to="/portfolio" className={linkClass} onClick={closeMenu}>
                Portfolio
              </Link>
            </li>
            <li>
              <Link to="/blog" className={linkClass} onClick={closeMenu}>
                Blog
              </Link>
            </li>
            <li>
              <Link to="/contactUs" className={linkClass} onClick={closeMenu}>
                Contact Us
              </Link>
            </li>
            <li className="md:hidden pt-2">
              <Link to="/contactUs" onClick={closeMenu}>
                <button
                  type="button"
                  className="w-full text-white bg-customRed neon-btn font-bold rounded-full text-sm px-6 py-3"
                >
                  Get a Quote
                </button>
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
